module.exports = __webpack_public_path__ + "static/media/todoistfinal.cf1d9c82.jpg";